import {useAuthorization} from "../../selectors";
import DialogBox from "../dialogs/dialog-box";
import React, {useEffect, useRef, useState} from "react";
import {getStaticVideoUrl, getUserAvatar} from "../../actions/environment";
import {useIsMobile, useLanguage} from "../configuration/configuration";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import SpaceAccessIcon from "../navigation/icons/space-access-icon";
import {PlyrVideoPlayer} from "../media-players/plyr-video-player";
import SimpleBarScroller from "../scrollbars/simple-bar-scroller";
import {MarkDownText} from "../toggler/markdown-text-toggler";
import NavigationUser from "../navigation/navigation-user";
import moment from "moment/moment";
import useIncrementMediaViewcount from "../hooks/use-increment-media-viewcount";
import {SUCCESS_STATUS} from "../../actions";
import {SpinnerBig} from "../util/spinner";
import {CloseIcon, fs_regular} from "../navigation/icons/nav-icons";

const PlayVideoReel = ({enrichedMedia, isOpen, setIsOpen}) => {
    const [access, setAccess] = useState(enrichedMedia.access);
    const plyrRef = useRef();
    const isMobile = useIsMobile();
    const {isAuthorized} = useAuthorization();
    const {incrementMediaViewcount, viewcount, status, error} = useIncrementMediaViewcount();
    const Lang = useLanguage();
    const videoUrl = getStaticVideoUrl(enrichedMedia.url);

    useEffect(() => {
        incrementMediaViewcount(enrichedMedia.id, (updatedMedia) => {
            // nothing
        });
    }, [enrichedMedia])

    const resolveUserAvatar = (enrichedMedia) => {
        return enrichedMedia.state != null && enrichedMedia.state === 'SHARED'
            ? enrichedMedia.from : enrichedMedia.user;
    }

    const handleOnClose = (event) => {
        event.preventDefault();
        setIsOpen(false);
    }
    const renderPostOwner = (enrichedMedia) => {
        const owner = resolveUserAvatar(enrichedMedia);

        const avatar = getUserAvatar(owner);
        return <div className="video-reel-user-header">
            <NavigationUser avatar={avatar} name={owner.fullname} to={`/${owner.username}/home`}/>
            <div className="comment-created" style={{marginLeft: "-0.5rem"}}>
                {Lang.userLink.posted} {moment(enrichedMedia.created).fromNow()}
            </div>
        </div>
    }

    if (status !== SUCCESS_STATUS) return <SpinnerBig/>
    const isLandscape = enrichedMedia.width > enrichedMedia.height;
    return <DialogBox title=""
                      action={null}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      isDisabled={!isAuthorized}
                      callback={null}
                      cancelButton={false}
                      wide={isLandscape}
                      header={false} className={isMobile ? "bg-dark" : ""}>

        <NavigationRow className='card-header'>
            <NavigationGroup>
                {renderPostOwner(enrichedMedia)}
            </NavigationGroup>
            <NavigationGroup>
                <SpaceAccessIcon access={access}/>
                <span className='btn btn-outline-primary dialog-box-close-btn ml-1' onClick={handleOnClose}>
                    <CloseIcon size={fs_regular}/>
                </span>
            </NavigationGroup>
        </NavigationRow>

        <div className='video-reel-player-container'>
            <div className={isLandscape ? "center-vertical-height": ""}>
                <PlyrVideoPlayer ref={plyrRef} autoplay={true} source={
                    {type: "video", sources: [{src: videoUrl}]}
                }/>
                <div className=" d-flex justify-content-end my-1 mr-1">
                    <span className="badge rounded-pill text-bg-secondary muted">{viewcount} Views</span>
                </div>
                <div>
                    <SimpleBarScroller className='video-reel-text'>
                        <MarkDownText text={enrichedMedia.text}/>
                    </SimpleBarScroller>
                </div>
            </div>
        </div>

    </DialogBox>
}

export default PlayVideoReel;